/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { setUpdateAvailable, handleControllerChange } from './services/appUpdate'

if (process.env.NODE_ENV === 'production') {
  // Only reloads when the controller change was caused by the user clicking
  // "Update Now" (see src/services/appUpdate.js) — never automatically.
  navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange)

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')

      // The browser only checks for a new service-worker.js on navigation,
      // so poll while the app stays open (long sessions, PWA installs) and
      // whenever the tab regains focus so updates aren't missed.
      setInterval(() => {
        registration.update()
      }, 60 * 60 * 1000)

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          registration.update()
        }
      })
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; the user can apply it from the update banner.')
      setUpdateAvailable(registration)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
